export const DISPLAY_NAME_DROPDOWN_MENU = "ProdesegDropdownMenu";
export const DISPLAY_NAME_DROPDOWN_TOGGLE = "ProdesegDropdownToggle";
export const FIRST_TIME_LOGIN = "firstTimeLogin";
